import Flex from '@components/Flex/Flex';
import { styled } from '@mui/material';

export const StyledContainer = styled(Flex)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[500]}`,
  padding: theme.spacing(12, 12),
  borderRadius: theme.spacing(10),
  flexDirection: 'row',
  alignItems: 'center',
  textAlign: 'left',
  backgroundColor: theme.palette.primary[50],
  gap: theme.spacing(10),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    flexWrap: 'nowrap',
    textAlign: 'center',
    justifyContent: 'center',
    gap: theme.spacing(14),
  },
}));

export const StyledLogoContainer = styled(Flex)(({ theme }) => ({
  width: 60,
  height: 60,
  borderRadius: theme.spacing(16),
  alignSelf: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.primary[700],
}));

export const StyledLogo = styled('img')(({ theme }) => ({
  width: 28,
  height: 28,
  objectFit: 'contain',
}));

export const TextContainer = styled(Flex)(({ theme }) => ({
  flex: 1,
  flexDirection: 'column',
  gap: theme.spacing(7),
  alignItems: 'flex-start',
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
  },
}));
